/**
 * 枚舉
 * Pinia
 * @author J
 * @since 2024-04-30 07:34:25
 */

export const PiniaEnum = Object.freeze({

    /**
     * 設定
     */
    SETTING: "v2.setting",

    /**
     * 授權 - 權杖
     */
    AUTHORIZATION_SESSION: "v2.authorization.session",

    /**
     * 列表 - 查詢條件保留
     */
    FILTER: "v2.filter",

})